import styled from 'styled-components';
import { Header, Footer } from '@gcc/pip-components/dist/ContentDrawer/styles';

export const ContentDrawerWrapper = styled.div`
  display: flex;
  flex: 2;
  ${Header} {
    box-sizing: unset;
    border-radius: 8px 8px 0 0;
    border-color: #fff;
    box-shadow: ${({ isOpen }) => (isOpen ? 'none' : '0px 0px 16px 3px rgba(0, 0, 0, 0.2);')};
  }

  ${Footer} {
    border: none;
    box-sizing: unset;
  }
`;

export const ButtonSection = styled.div`
  padding: 1rem;
  p {
    font-size: 12px;
    margin-top: 2rem;
    text-align: center;
  }
  a {
    text-decoration: underline;
  }

`;

export const Wrapper = styled.div`
  padding: 1.6rem;
  display: flex;
  justify-content: space-between;
  align-content: center;
`;